<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">{{ position.id ? 'Edit' : 'New' }} postdoctoral position & fellowship<br>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to professional background"
              @click="$router.push({name: 'researcher.postdoctoral-positions.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Research lines settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">
            <SearchResearcher :item="position" />

            <div class="card">
              <div class="card-header">
                <h3 class="cart-title">
                  <a data-action="collapse">Basic information</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label d-block"
                        >Position <a
                          class="float-end text-danger"
                          @click="togglePosition"
                        ><i data-feather="alert-triangle" /> Position not listed</a></label>
                        <v-select
                          v-if="!manualPosition"
                          v-model="position.position"
                          label="name"
                          :options="positions"
                          :get-option-key="option => option.id"
                        />
                        <input
                          v-else
                          v-model="position.position_manual"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row row-md-2">
                    <div class="col">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >Begin year</label>
                        <date-picker
                          v-model="position.begin_year"
                          format="Y"
                          type="year"
                          value-type="format"
                          class="w-100"
                        />
                      </div>
                    </div>
                    <div class="col">
                      <div class="mb-1 form-group required">
                        <label
                          for=""
                          class="form-label"
                        >End year</label>
                        <date-picker
                          v-model="position.end_year"
                          format="Y"
                          type="year"
                          value-type="format"
                          class="w-100"
                        />
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col">
                      <div class="form-check form-check-success form-switch d-flex align-items-center">
                        <input
                          id=""
                          v-model="position.published_web"
                          type="checkbox"
                          class="form-check-input"
                          checked
                        >
                        <label
                          class="form-check-label"
                          for=""
                        ><small class="ms-1">Publish in web </small></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InstitutionAndDepartment
              v-if="!loading"
              :item="position"
              :show-address="false"
              :show-country="true"
              :required-fields="true"
            />

            <AddFile
              :id="6"
              :title="'Files'"
              :type="3"
              :files="position.certificates"
              @saveAnswer="saveFiles"
            />
          </div>
        </div>
        <div class="page-actions">
          <button
            v-if="!loading"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" /> <span class="ms-25 align-middle"> Save and Exit</span>
          </button>
          <button
            v-if="loading"
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import AddFile from '../../admin/senior-call/components/AddFile.vue'
import SearchResearcher from '../../partials/components/SearchResearcher.vue'
import InstitutionAndDepartment from '../../partials/components/InstitutionAndDepartment.vue'
import 'vue2-datepicker/index.css'

export default {
  components: {
    vSelect,
    AddFile,
    SearchResearcher,
    InstitutionAndDepartment,
    DatePicker,
  },
  data() {
    return {
      positionId: this.$route.params.id,
      loading: true,
      selectedInstitution: null,
      manualInstitution: false,
      manualPosition: false,
    }
  },
  computed: {
    ...mapGetters({
      position: 'positions/position',
      positions: 'positions/positionsList',
      institutions: 'institutions/institutions',
    }),
  },
  async mounted() {
    if (this.positionId) {
      await this.$store.dispatch('positions/fetchPosition', this.positionId)
      this.$store.dispatch('positions/fetchPositionsList')
      this.manualPosition = this.position.position_manual != null
    } else {
      this.$store.dispatch('positions/removePosition')
    }

    this.loading = false
  },
  methods: {
    togglePosition() {
      this.manualPosition = !this.manualPosition
      this.position.position = null
      this.position.position_manual = ''
    },
    async save() {
      this.loading = true
      try {
        if (this.positionId) {
          await this.$store.dispatch('positions/update', { positionId: this.position.id, data: this.position })
        } else {
          await this.$store.dispatch('positions/create', this.position)
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.position.id) {
        Vue.swal('Post doctoral position updated successfully!', '', 'success').then(() => {
          this.$router.push({ name: 'researcher.postdoctoral-positions.index' })
        })
      }

      this.loading = false
    },
    saveFiles(files) {
      this.position.files_new = files.data
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
  },
}
</script>
